module.exports = __webpack_public_path__ + "6b86427f26b8d842709241a5416f8aae.png";